module.exports = __webpack_public_path__ + "static/media/IOMS.9f944b70.svg";